export default __webpack_public_path__ + "static/media/docker.1d41320c.svg";